import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ServicesRatesService } from '../../../services/servicesRatesService';
import { ServiceRate } from '../../../models/ServiceRate';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-add-rate-category',
  templateUrl: './add-rate-category.component.html',
  styleUrls: ['./add-rate-category.component.scss'],
})
export class AddRateCategoryComponent implements OnInit {
  serviceId: number;
  serviceRate: ServiceRate;
  constructor(private diagRef: NbDialogRef<AddRateCategoryComponent>,
       private route : Router,
     private service: ServicesRatesService) {
    this.serviceRate = {} as ServiceRate;
    this.serviceRate.serviceId = this.serviceId;
  }

  ngOnInit(): void {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
  }

  add() {
    this.serviceRate.serviceId = this.serviceId;
    this.service.post(this.serviceRate).subscribe((res) => {
      this.diagRef.close('true');
    });
  }
}
